// extracted by mini-css-extract-plugin
export default {"form":"EditarUsuario_form__JU2xT","areaBtn":"EditarUsuario_areaBtn__+jBXX","btn":"EditarUsuario_btn__Kjp-n"};